import {effect, inject} from '@angular/core';
import {signalStore, withHooks, withState} from '@ngrx/signals';
import {ResourcesService} from '../services/resources.service';
import {initialGameState} from './game-state.model';
import {withAnswers} from './features/with-answers.feature';
import {withError} from './features/with-error.feature';
import {withGameData} from './features/with-game-data.feature';
import {withInfoModal} from './features/with-info-modal.feature';
import {withLocalStoragePersistence} from './features/with-local-storage-persistence.feature';
import {withQuestionFlow} from './features/with-question-flow.feature';
import {withScore} from './features/with-score.feature';

/**
 * The single source of truth for the game state, composed from feature slices:
 * - {@link withGameData} — read-only, resource-derived configuration.
 * - {@link withScore} — score computation.
 * - {@link withAnswers} — guesses and answer options.
 * - {@link withQuestionFlow} — starting/stopping games and question progression.
 * - {@link withError} — user-facing error handling.
 * - {@link withInfoModal} — tracks whether a game-instructions modal is open.
 */
export const GameStore = signalStore(
  {providedIn: 'root', protectedState: false},
  withState(initialGameState),
  withGameData(),
  withScore(),
  withAnswers(),
  withQuestionFlow(),
  withError(),
  withInfoModal(),
  withLocalStoragePersistence(),
  withHooks({
    onInit(store, resources = inject(ResourcesService)) {
      // Surface resource loading failures as game errors.
      effect(() => {
        if (resources.mapConfig.error()) {
          store.setError('mapConfigError');
        }
      });
      effect(() => {
        if (resources.gameData.error()) {
          store.setError('questionsError');
        }
      });
    },
  })
);
